<template>
  <div
    :class="[
      $style.container,
      {
        [$style['container--messageFromOppositeUser']]: isOppositeUser,
      },
    ]"
  >
    <div :class="$style.container__status">
      <span v-if="hasBeenRead">既読</span>
      <span>{{ formatDateTimeForChatMessage(date) }}</span>
    </div>
    <div
      :class="[
        $style.container__content,
        {
          [$style['container__content--messageFromOppositeUser']]:
            isOppositeUser,
        },
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  type ChatMessageUserType,
  BizChatMessageUserType,
} from '@/components/organisms/ChatMessageList/ChatMessageUserType'
import { formatDateTimeForChatMessage } from '@/libs/utilities/formatDate'

const props = defineProps<{
  date: Date
  userType: ChatMessageUserType
  hasBeenRead: boolean
}>()

const isOppositeUser = !BizChatMessageUserType.includes(props.userType)
</script>

<style module lang="scss">
.container {
  display: flex;
  justify-content: flex-end;
  align-items: bottom;
  gap: 8px;

  &--messageFromOppositeUser {
    flex-direction: row-reverse;
  }

  &__status {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    color: $color-text-and-object-low-emphasis;
    font-size: 12px;
  }

  &__content {
    border-radius: $border-radius-v2-rounder;
    box-shadow: $shadow-24;
    width: fit-content;
    padding: 12px;
    background-color: $color-surface-accent-primary;
    color: $color-text-and-object-high-emphasis-inverse;

    &:nth-child(n + 1) {
      margin-top: 8px;
    }

    &--messageFromOppositeUser {
      // FIXME: ユーザーアイコン分の空白
      // Message Item に slot で差し込めるようにしたほうがいい
      margin-left: 68px;
      background-color: $color-surface-primary;
      color: $color-text-and-object-high-emphasis;
    }
  }
}
</style>
